// Get URL parameters
$.urlParam = function (name) {
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	if (results == null) {
		return null;
	}
	else {
		return results[1] || 0;
	}
}

// Populate climber dropdown menu items and filter by selection
$(function () {

	var dropdown = $(".country-filter"),
		climbers = $(".climber-profile"),
		filterCountry = $.urlParam("country");

	// Hide any filtered profiles
	if (filterCountry !== null) {
		$.each(climbers, function () {
			if ($(this).data("origin") == filterCountry.replace("+", " ").replace("%20", " ")) {
				$(this).removeClass("hidden-xs-up");
			}
		});
	} else if (climbers.length > 0) {
		$.each(climbers, function () {
			$(this).removeClass("hidden-xs-up");
		});
	}

	if (dropdown.length > 0 && climbers.length > 0) {

		var countries = [];

		// Determine whether to show 0 results found for individual sections
		var climberCount = 0;
		var ambassadorCount = 0;
		var youthCount = 0;

		// Loop through each climber profile
		$.each(climbers, function () {

			var country = $(this).data("origin"),
				profileType = $(this).data("profile");

			// Add to country array if it doesn't already exist
			if (jQuery.inArray(country, countries) === -1) {
				countries.push(country);
			}

			// Add to climber/ambassador count if the profile isn't hidden
			if (!$(this).hasClass("hidden-xs-up")) {
				if (profileType == "climber") {
					climberCount++;
				} else if (profileType == "ambassador") {
					ambassadorCount++;
				} else if (profileType == "youth") {
					youthCount++;
				}
			}

		});

		// Show 0 results found message for relevant section(s)
		if (climberCount == 0) {
			$(".climber-zero-results").removeClass("hidden-xs-up");
		}
		if (ambassadorCount == 0) {
			$(".ambassador-zero-results").removeClass("hidden-xs-up");
		}
		if (youthCount == 0) {
			$(".youth-zero-results").removeClass("hidden-xs-up");
		}

		if (countries.length > 0) {

			// Sort the countries alphabeticallly
			var sortedCountries = countries.sort(),
				options = "";

			// Turn the array of countries into selectable options
			for (var i = 0; i < sortedCountries.length; i++) {
				options += '<option value="' + sortedCountries[i] + '">' + sortedCountries[i] + '</option>';
			}

			// Add to the previously empty dropdown
			dropdown.append(options);
		}
		else {
			dropdown.addClass("hidden-xs-up");
		}

		// Default the dropdown to the selected option if applicable
		if (filterCountry !== null) {
			dropdown.val(filterCountry.replace("+", " ").replace("%20", " "));
		}

		// Allow users to filter when changing country option
		$(".country-filter").on("change", function () {

			// If default value is selected, revert to normal view i.e. all results
			if ($(this).val() == "") {
				window.location.href = window.location.pathname;
			} else {
				window.location.href = window.location.pathname + "?" + $.param({ 'country': $(this).val() })
			}

		});
	}

});